{
  "name": "iotzen_platform",
  "version": "10.1.9-next",
  "private": true,
  "license": "LICENSED",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --configuration local",
    "host-local": "ng serve --configuration=local --host 0.0.0.0",
    "build": "ng build --configuration dev",
    "build-sm": "node --max_old_space_size=8048 ./node_modules/@angular/cli/bin/ng build --configuration production --stats-json  --source-map",
    "run-dev": "node --max_old_space_size=4048 ./node_modules/@angular/cli/bin/ng serve --configuration local",
    "test": "ng test",
    "lint": "ng lint",
    "e2e": "ng e2e",
    "analyse": "webpack-bundle-analyzer dist/stats.json",
    "build-serve": "node --max_old_space_size=8048 ./node_modules/@angular/cli/bin/ng serve",
    "explore": "npm run build-sm; source-map-explorer dist/**/*.js",
    "update": "ng update @angular/core@19 @angular/cli@19 --force",
    "cf": "ng generate @angular/core:control-flow",
    "standlonw": "ng generate @angular/core:standalone",
    "state-migration": "ng update @ngrx/store@18",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org zendynamix --project iotzen-ui ./dist && sentry-cli sourcemaps upload --org zendynamix --project iotzen-ui ./dist"
  },
  "dependencies": {
    "@acrodata/code-editor": "^0.5.1",
    "@angular/animations": "^19.2.2",
    "@angular/cdk": "19.2.3",
    "@angular/common": "^19.2.2",
    "@angular/compiler": "^19.2.2",
    "@angular/core": "^19.2.2",
    "@angular/forms": "^19.2.2",
    "@angular/localize": "^19.2.2",
    "@angular/material": "19.2.3",
    "@angular/material-moment-adapter": "19.2.3",
    "@angular/platform-browser": "^19.2.2",
    "@angular/platform-browser-dynamic": "^19.2.2",
    "@angular/pwa": "^19.2.3",
    "@angular/router": "^19.2.2",
    "@angular/service-worker": "^19.2.2",
    "@bluehalo/ngx-leaflet-markercluster": "^19.0.0",
    "@bluehalo/ngx-leaflet": "^19.0.0",
    "@casl/ability": "^6.7.3",
    "@casl/angular": "^9.0.3",
    "@ngrx/effects": "^19.0.1",
    "@ngrx/store": "^19.0.1",
    "@ngx-translate/core": "^16.0.4",
    "@sentry/angular": "^9.6.0",
    "ang-jsoneditor": "^3.1.1",
    "jsoneditor": "^9.10.5",
    "angular-calendar": "^0.31.1",
    "buffer": "^6.0.3",
    "chart.js": "^4.4.8",
    "echarts": "^5.6.0",
    "file-saver": "^2.0.5",
    "firebase": "^11.1.0",
    "font-awesome": "^4.7.0",
    "l.movemarker": "^0.0.12",
    "leaflet": "^1.9.4",
    "leaflet.gridlayer.googlemutant": "^0.14.1",
    "leaflet.markercluster": "^1.5.3",
    "lodash": "^4.17.21",
    "marked": "^15.0.7",
    "moment": "^2.30.1",
    "moment-timezone": "^0.5.45",
    "ngx-echarts": "^19.0.0",
    "ngx-webcam": "^0.4.1",
    "primeflex": "^4.0.0",
    "primeicons": "^7.0.0",
    "primeng": "^19.0.9",
    "@primeng/themes": "^19.0.9",
    "print-js": "^1.6.0",
    "quill": "^2.0.3",
    "razorpay": "^2.9.5",
    "rxjs": "^7.8.1",
    "socket.io-client": "^4.8.1",
    "tslib": "^2.6.3",
    "xlsx": "^0.18.5",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.2.3",
    "@angular-eslint/builder": "^19.2.1",
    "@angular-eslint/eslint-plugin": "^19.2.1",
    "@angular-eslint/eslint-plugin-template": "^19.2.1",
    "@angular-eslint/schematics": "^19.2.1",
    "@angular-eslint/template-parser": "^19.2.1",
    "@angular/cli": "^19.2.3",
    "@angular/compiler-cli": "^19.2.2",
    "@angular/language-service": "^19.2.2",
    "@ngrx/store-devtools": "^19.0.1",
    "@popperjs/core": "^2.11.8",
    "@sentry/cli": "^2.42.3",
    "@types/echarts": "^5.0.0",
    "@types/jasmine": "~5.1.4",
    "@types/jasminewd2": "^2.0.13",
    "@types/leaflet": "^1.9.16",
    "@types/leaflet.markercluster": "^1.5.4",
    "@types/lodash": "^4.17.7",
    "@types/moment": "^2.13.0",
    "@types/node": "^22.13.10",
    "@types/socket.io-client": "^3.0.0",
    "@typescript-eslint/eslint-plugin": "^8.22.0",
    "@typescript-eslint/parser": "^8.22.0",
    "eslint": "^9.19.0",
    "jasmine-core": "~5.1.2",
    "jasmine-spec-reporter": "^7.0.0",
    "karma": "^6.4.3",
    "karma-chrome-launcher": "^3.2.0",
    "karma-coverage-istanbul-reporter": "~3.0.3",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "^2.1.0",
    "protractor": "~7.0.0",
    "source-map-explorer": "^2.5.3",
    "ts-node": "^10.9.2",
    "typescript": "~5.6.3"
  }
}
